import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux';
import { selectIsAuthenticated, selectIsAuthInitialized } from '../features/AuthSlice/AuthSelectors';
import { loginVerified } from '../features/AuthSlice/AuthSlice';
import { getMembershipLoginUrl } from '../constants/urls';
export const useLoginVerify = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isAuthInitialized = useAppSelector(selectIsAuthInitialized);
  const membershipLoginUrl = useMemo(() => getMembershipLoginUrl(window.location.href), []);
  useEffect(() => {
    void dispatch(loginVerified());
  }, [dispatch]);
  useEffect(() => {
    // redirect to Membership Platform login if auth check has settled and user is not authenticated
    if (isAuthInitialized && !isAuthenticated) {
      window.location.replace(membershipLoginUrl);
    }
  }, [isAuthenticated, isAuthInitialized, membershipLoginUrl]);
  return {
    loading: !isAuthInitialized,
    isLoggedIn: isAuthenticated
  };
};